export const regions = ["Africa", "Americas", "Asia", "Oceania", "Europe"];

export const regionCountryLists = {
    "Africa": [
        "Algeria",
        "Angola",
        "Benin",
        "Botswana",
        "British Indian Ocean Territory",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cameroon",
        "Central African Republic",
        "Chad",
        "Comoros",
        "Congo",
        "Congo, Democratic Republic of the",
        "Côte d'Ivoire",
        "Djibouti",
        "Egypt",
        "Equatorial Guinea",
        "Eritrea",
        "Eswatini",
        "Ethiopia",
        "French Southern Territories",
        "Gabon",
        "Gambia",
        "Ghana",
        "Guinea",
        "Guinea-Bissau",
        "Kenya",
        "Lesotho",
        "Liberia",
        "Libya",
        "Madagascar",
        "Malawi",
        "Mali",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Morocco",
        "Mozambique",
        "Namibia",
        "Niger",
        "Nigeria",
        "Réunion",
        "Rwanda",
        "Saint Helena, Ascension and Tristan da Cunha",
        "Sao Tome and Principe",
        "Senegal",
        "Seychelles",
        "Sierra Leone",
        "Somalia",
        "South Africa",
        "South Sudan",
        "Sudan",
        "Tanzania, United Republic of",
        "Togo",
        "Tunisia",
        "Uganda",
        "Western Sahara",
        "Zambia",
        "Zimbabwe"
    ],
    "Americas": [
        "Anguilla",
        "Antigua and Barbuda",
        "Argentina",
        "Aruba",
        "Bahamas",
        "Barbados",
        "Belize",
        "Bermuda",
        "Bolivia (Plurinational State of)",
        "Bonaire, Sint Eustatius and Saba",
        "Bouvet Island",
        "Brazil",
        "Canada",
        "Cayman Islands",
        "Chile",
        "Colombia",
        "Costa Rica",
        "Cuba",
        "Curaçao",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "El Salvador",
        "Falkland Islands (Malvinas)",
        "French Guiana",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guatemala",
        "Guyana",
        "Haiti",
        "Honduras",
        "Jamaica",
        "Martinique",
        "Mexico",
        "Montserrat",
        "Nicaragua",
        "Panama",
        "Paraguay",
        "Peru",
        "Puerto Rico",
        "Saint Barthélemy",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin (French part)",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Sint Maarten (Dutch part)",
        "South Georgia and the South Sandwich Islands",
        "Suriname",
        "Trinidad and Tobago",
        "Turks and Caicos Islands",
        "United States of America",
        "Uruguay",
        "Venezuela (Bolivarian Republic of)",
        "Virgin Islands (British)",
        "Virgin Islands (U.S.)"
    ],
    "Asia": [
        "Afghanistan",
        "Armenia",
        "Azerbaijan",
        "Bahrain",
        "Bangladesh",
        "Bhutan",
        "Brunei Darussalam",
        "Cambodia",
        "China",
        "Cyprus",
        "Georgia",
        "Hong Kong",
        "India",
        "Indonesia",
        "Iran (Islamic Republic of)",
        "Iraq",
        "Israel",
        "Japan",
        "Jordan",
        "Kazakhstan",
        "Korea (Democratic People's Republic of)",
        "Korea, Republic of",
        "Kuwait",
        "Kyrgyzstan",
        "Lao People's Democratic Republic",
        "Lebanon",
        "Macao",
        "Malaysia",
        "Maldives",
        "Mongolia",
        "Myanmar",
        "Nepal",
        "Oman",
        "Pakistan",
        "Palestine, State of",
        "Philippines",
        "Qatar",
        "Saudi Arabia",
        "Singapore",
        "Sri Lanka",
        "Syrian Arab Republic",
        "Taiwan, Province of China",
        "Tajikistan",
        "Thailand",
        "Timor-Leste",
        "Turkey",
        "Turkmenistan",
        "United Arab Emirates",
        "Uzbekistan",
        "Viet Nam",
        "Yemen"
    ],
    "Oceania": [
        "American Samoa",
        "Australia",
        "Christmas Island",
        "Cocos (Keeling) Islands",
        "Cook Islands",
        "Fiji",
        "French Polynesia",
        "Guam",
        "Heard Island and McDonald Islands",
        "Kiribati",
        "Marshall Islands",
        "Micronesia (Federated States of)",
        "Nauru",
        "New Caledonia",
        "New Zealand",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands",
        "Palau",
        "Papua New Guinea",
        "Pitcairn",
        "Samoa",
        "Solomon Islands",
        "Tokelau",
        "Tonga",
        "Tuvalu",
        "United States Minor Outlying Islands",
        "Vanuatu",
        "Wallis and Futuna"
    ],
    "Europe": [
        "Åland Islands",
        "Albania",
        "Andorra",
        "Austria",
        "Belarus",
        "Belgium",
        "Bosnia and Herzegovina",
        "Bulgaria",
        "Croatia",
        "Czechia",
        "Denmark",
        "Estonia",
        "Faroe Islands",
        "Finland",
        "France",
        "Germany",
        "Gibraltar",
        "Greece",
        "Guernsey",
        "Holy See",
        "Hungary",
        "Iceland",
        "Ireland",
        "Isle of Man",
        "Italy",
        "Jersey",
        "Latvia",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Malta",
        "Moldova, Republic of",
        "Monaco",
        "Montenegro",
        "Netherlands",
        "North Macedonia",
        "Norway",
        "Poland",
        "Portugal",
        "Romania",
        "Russian Federation",
        "San Marino",
        "Serbia",
        "Slovakia",
        "Slovenia",
        "Spain",
        "Svalbard and Jan Mayen",
        "Sweden",
        "Switzerland",
        "Ukraine",
        "United Kingdom of Great Britain and Northern Ireland"
    ],
    "European Union" : [
        "Austria",
        "Belgium",
        "Bulgaria",
        "Croatia",
        "Cyprus",
        "Czechia",
        "Denmark",
        "Estonia",
        "Finland",
        "France",
        "Germany",
        "Greece",
        "Hungary",
        "Ireland",
        "Italy",
        "Latvia",
        "Lithuania",
        "Luxembourg",
        "Malta",
        "Netherlands",
        "Poland",
        "Portugal",
        "Romania",
        "Slovakia",
        "Slovenia",
        "Spain",
        "Sweden",
    ]
};